import { Box, Paper, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import { tokens } from "../../theme";
import ValidateOtpForm from "../../components/authenticate/ValidateOtpForm";

export default observer(function ValidateOtp() {
  const { state } = useLocation();
  const colors = tokens();

  return (
    <div className="login-container">
      <div className="login-container_left"></div>
      <div className="login-container_right">
        <Paper
          sx={{
            p: 5,
          }}
        >
          <Box
            sx={{
              mb: 2,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: `${colors.blue[300]}`,
                fontWeight: "bold",
                fontSize: "2rem",
                textAlign: "center",
              }}
            >
              One-Time-Password
            </Typography>
          </Box>

          <ValidateOtpForm />
        </Paper>
      </div>
    </div>
  );
});
